import React from "react";
import { Instagram, Facebook, Twitter, Youtube, Plus } from "lucide-react";

const StorePreview = ({ store }) => {
  const socialIcons = {
    instagram: Instagram,
    facebook: Facebook,
    twitter: Twitter,
    youtube: Youtube,
  };

  return (
    <div className="store-preview px-2 py-2">
      <div className="mb-3">
        <img
          src={store.image || "https://via.placeholder.com/400x500"}
          alt={store.domain}
          className="img-fluid w-100 rounded"
          style={{ objectFit: "cover", height: "400px" }}
        />
      </div>
      <div className="d-flex justify-content-start gap-4 align-items-center mb-3">
        <h4 className="mb-0">{store.domain}</h4>
        <span className="badge bg-dark">{store.score}</span>
      </div>
      <div className="social-links">
        {Object.entries(store.social || {}).map(([platform, url]) => {
          const Icon = socialIcons[platform];
          return (
            <a
              key={platform}
              href={url}
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon size={16} />
            </a>
          );
        })}
        <button className="social-link border-0">
          <Plus size={16} />
        </button>
      </div>
    </div>
  );
};

export default StorePreview;
